export default "__VITE_ASSET__Bpqfnmqx__"